/**
 * Plan-pricing constants with NO module dependencies, so build tooling
 * (`scripts/generate-pricing.mjs`, run standalone via Node type-stripping) can
 * import them without pulling in the rest of pricing-plans.ts — which imports
 * the generated price file and so can't be loaded by a plain Node script.
 * Re-exported from pricing-plans.ts for app code, so call sites keep importing
 * from there.
 */

/** The plan ids that carry a Stripe price (Free / Business have none). The
 *  single place the paid-tier set is enumerated: the build-time price
 *  generator and the generated `Record` key type both derive from this, so
 *  adding a paid tier is one edit here (plus the matching Stripe products and
 *  STRIPE_LOOKUP_* env). Kept in PLANS order. */
export const PAID_PLAN_IDS = ['pro', 'pro-family'] as const;
export type PaidPlanId = (typeof PAID_PLAN_IDS)[number];

/** Advertised/intended annual discount across paid plans (ADR-0062). The
 *  "Save N%" badge is computed from the live prices (`annualDiscountPercent`),
 *  not this constant — this is the documented target the seed prices are
 *  tested against. */
export const ANNUAL_DISCOUNT_PERCENT = 20;

/** Default free-trial window for first-time subscribers. */
export const DEFAULT_TRIAL_DAYS = 7;
